export default "__VITE_ASSET__Bl22K6HP__"